import { ILimitedListUser } from "@/interfaces/Project/Roles/ILimitedListUser";

export const convertLimitedListUsersToIds = (
  limitedList: ILimitedListUser[]
): string[] => limitedList.map((user) => user.userId);
